import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from './components/Layout';
import { API_BASE_URL } from './config';

function ChangePassword() {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Validation
    if (newPassword !== confirmPassword) {
      setError('Neue Passwörter stimmen nicht überein');
      return;
    }

    if (newPassword.length < 8) {
      setError('Neues Passwort muss mindestens 8 Zeichen lang sein');
      return;
    }

    if (newPassword === oldPassword) {
      setError('Neues Passwort muss sich vom alten unterscheiden');
      return;
    }

    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/change-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          old_password: oldPassword,
          new_password: newPassword
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.detail || 'Fehler beim Ändern des Passworts');
      }

      setSuccess('Passwort erfolgreich geändert!');
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');

      // Redirect to dashboard after 2 seconds
      setTimeout(() => {
        navigate('/');
      }, 2000);

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title="Passwort ändern">
      <div className="card" style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h2 className="card-header" style={{ marginBottom: 'var(--space-5)' }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 'var(--space-2)', verticalAlign: 'middle' }}>
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Passwort ändern
        </h2>

        {error && (
          <div style={{
            padding: 'var(--space-3)',
            marginBottom: 'var(--space-4)',
            backgroundColor: 'var(--danger-bg)',
            border: '1px solid var(--danger)',
            borderRadius: 'var(--radius-md)',
            color: 'var(--danger)',
            fontSize: 'var(--font-size-sm)',
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--space-2)'
          }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            {error}
          </div>
        )}

        {success && (
          <div style={{
            padding: 'var(--space-3)',
            marginBottom: 'var(--space-4)',
            backgroundColor: 'var(--success-bg)',
            border: '1px solid var(--success)',
            borderRadius: 'var(--radius-md)',
            color: 'var(--success)',
            fontSize: 'var(--font-size-sm)',
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--space-2)'
          }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            {success}
          </div>
        )}

        <form onSubmit={handleSubmit} className="form-grid">
          <div className="form-group">
            <label className="form-label">Altes Passwort</label>
            <input
              type="password"
              name="current-password"
              autoComplete="current-password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
              autoFocus
              placeholder="Aktuelles Passwort eingeben"
              style={{ fontSize: 'var(--font-size-md)' }}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Neues Passwort</label>
            <input
              type="password"
              name="new-password"
              autoComplete="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              placeholder="Mindestens 8 Zeichen"
              style={{ fontSize: 'var(--font-size-md)' }}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Neues Passwort bestätigen</label>
            <input
              type="password"
              name="confirm-password"
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              placeholder="Neues Passwort wiederholen"
              style={{ fontSize: 'var(--font-size-md)' }}
            />
          </div>

          <div style={{
            gridColumn: '1 / -1',
            display: 'flex',
            gap: 'var(--space-3)',
            marginTop: 'var(--space-4)'
          }}>
            <button
              type="submit"
              className="btn-primary"
              disabled={loading}
              style={{ flex: '0 0 auto' }}
            >
              {loading ? 'Wird geändert...' : 'Passwort ändern'}
            </button>
            <button
              type="button"
              className="btn-secondary"
              onClick={() => navigate('/')}
              style={{ flex: '0 0 auto' }}
            >
              Abbrechen
            </button>
          </div>
        </form>

        <div style={{
          marginTop: 'var(--space-5)',
          padding: 'var(--space-4)',
          background: 'var(--bg-secondary)',
          borderRadius: 'var(--radius-md)',
          fontSize: 'var(--font-size-sm)',
          color: 'var(--text-secondary)',
          display: 'flex',
          alignItems: 'flex-start',
          gap: 'var(--space-3)'
        }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0, marginTop: '2px' }}>
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="16" x2="12" y2="12"/>
            <line x1="12" y1="8" x2="12.01" y2="8"/>
          </svg>
          <div>
            <div style={{ fontWeight: '600', marginBottom: 'var(--space-1)', color: 'var(--text-primary)' }}>
              Sicherheitshinweis
            </div>
            Nach dem Ändern des Passworts bleibst du eingeloggt. Dein neues Passwort wird beim nächsten Login verwendet.
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default ChangePassword;
